import React from 'react';
import PrintLayout from '../PrintLayout';

const CATEGORIES = [
  { key: 'cc', label: 'Compelling Content' },
  { key: 'hb', label: 'Healthy Behaviors' },
  { key: 'rg', label: 'Right Chemistry' },
  { key: 'sp', label: 'Simple Process' },
];

export default function PrintSummaryV2({ pageNumber, inventoryScores, meeting }) {
  const overall = Math.round(inventoryScores?.overall ?? 0);

  return (
    <PrintLayout pageNumber={pageNumber}>
      <div style={{ position: 'absolute', top: 0, bottom: 68, left: 0, right: 0, padding: '4% 5%', background: '#f5f4f0', display: 'flex' }}>
        <div style={{ flex: '0 0 30%', display: 'flex', flexDirection: 'column', gap: 14, paddingRight: 20 }}>
          <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 24, fontWeight: 700, color: '#1e2e45', marginBottom: 4 }}>
            Summary
          </div>
          <div style={{ background: '#1e2e45', borderRadius: 10, padding: '18px 20px', textAlign: 'center' }}>
            <div style={{ fontSize: 8.5, fontWeight: 700, letterSpacing: '1.2px', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', marginBottom: 6 }}>Overall</div>
            <div style={{ fontSize: 34, fontWeight: 800, color: '#fff' }}>{overall}%</div>
          </div>
          {CATEGORIES.map(({ key, label }) => (
            <div key={key} style={{ background: 'white', border: '1px solid rgba(42,61,91,0.1)', borderRadius: 10, padding: '10px 14px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                <div style={{ fontSize: 9.5, fontWeight: 700, color: '#2a3d5b' }}>{label}</div>
                <div style={{ fontSize: 10, fontWeight: 800, color: '#1e2e45' }}>{Math.round(inventoryScores?.[key] ?? 0)}%</div>
              </div>
              <div style={{ height: 5, background: '#ececed', borderRadius: 3 }}>
                <div style={{ height: '100%', borderRadius: 3, background: '#5f7942', width: `${inventoryScores?.[key] ?? 0}%` }} />
              </div>
            </div>
          ))}
        </div>

        <div style={{ flex: 1, background: 'white', border: '1px solid rgba(42,61,91,0.1)', borderRadius: 10, padding: '3% 4%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: '1.5px', color: '#6b757e', textTransform: 'uppercase', marginBottom: 14, fontFamily: 'Montserrat, sans-serif' }}>
            Meeting Feedback
          </div>
          {meeting?.meetingFeedback ? (
            <>
              <div style={{ fontSize: 11.5, color: '#2a3d5b', lineHeight: 1.85, whiteSpace: 'pre-wrap', flex: 1, overflow: 'hidden' }}>
                {meeting.meetingFeedback}
              </div>
              <div style={{ fontSize: 9.5, color: '#6b757e', fontWeight: 600, marginTop: 16 }}>
                — {meeting.consultantName || 'Consultant'}, condensed from live notes during post-meeting review
              </div>
            </>
          ) : (
            <div style={{ fontSize: 10, color: '#6b757e', fontStyle: 'italic' }}>No meeting feedback recorded.</div>
          )}
        </div>
      </div>
    </PrintLayout>
  );
}
